import {defineStore} from 'pinia';

type State = {
    combinationModels: Record<string, string | false>
}

export const useCombinationModelStore = defineStore('combinationModel', {
    state: (): State => ({
        combinationModels: {},
    }),

    actions: {
        async check(article: { articleNumber?: string }) {
            const articleNumber = article?.articleNumber;
            if (!articleNumber) return false;

            if (this.combinationModels[articleNumber] === undefined) {
                try {
                    const {public: pub} = useRuntimeConfig();

                    // Backend liefert offenbar { id: string }
                    const res = await $fetch<{ id?: string }>(
                        `${pub.configuratorURL}/get3DModelByArticleNumber/${encodeURIComponent(articleNumber)}`,
                        {credentials: 'omit'},
                    );
                    this.combinationModels[articleNumber] = res?.id ? String(res.id) : false;
                } catch (e) {
                    console.error('failed to check 3D model', e);
                    this.combinationModels[articleNumber] = false;
                }
            }

            return this.combinationModels[articleNumber];
        },
    },
});
